import React from 'react';
import Section from '../Section/Section';
import './PageBuilder.css';

/**
 * PageBuilder - Componente que construye una página a partir de un array de secciones
 * @param {Array} sections - Array de objetos con tipo y datos de cada sección
 */
const PageBuilder = ({ sections = [] }) => {
  return (
    <div className="page-builder">
      {sections.map((section, index) => (
        <Section
          key={`${section.type}-${index}`}
          type={section.type}
          data={section.data}
          sectionId={section.anchor}
        />
      ))}
    </div>
  );
};

export default PageBuilder;
